import { render } from "./StageBlock.vue?vue&type=template&id=167bd26a"
import script from "./StageBlock.vue?vue&type=script&lang=js"
export * from "./StageBlock.vue?vue&type=script&lang=js"

import "./StageBlock.vue?vue&type=style&index=0&id=167bd26a&lang=scss&scope=true"
import "./StageBlock.vue?vue&type=style&index=1&id=167bd26a&lang=css"

import exportComponent from "/data/projects/private_futurelab/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__